export const projectsData = [
  {
    id: 1,
    title: "O centaurach",
    date: "1936",
    languages: [
      "O centaurach",
      "Proces",
      "Pycha",
      "Canticum canticorum",
      "...",
    ],
    infos:
      "Ścierają się rym o rym ostrzone wiersze ze szczękiem — nie ufaj ścisłym rozmysłom, by żaden cię nie opętał, — nie ufaj palcom, jak ślepcy, ni oczom, jak sowy bezrękie. Oto głoszę namiętność i mądrość ciasno w pasie zrośnięte jak centaur.",
    img: "./assets/img/3.jpg",
    link: "https://culture.pl/pl/tworca/zuzanna-ginczanka",
  },
  {
    id: 2,
    title: "Wiersze wybrane",
    date: "1953",
    languages: ["Wybrał i wstępem opatrzył Jan Śpiewak. Czytelnik, Warszawa"],
    infos:
      "Brukom ulic się dziwić przez okna, liczyć wrony i łykać dzisiejszość, wszystkie myśli odrzucać od siebie i zostawiać jedynie najmniejszą, nie nazywać niczego słowami, nie wyplatać ze wzruszeń określeń, nie wpisywać w zeszyty spostrzeżeń, definicji nie sączyć z uniesień. –",
    img: "./assets/img/4.jpg",
    link:
      "https://kultura.gazetaprawna.pl/artykuly/1485580,izolda-kiec-ginczanka-wywiad.html",
  },
  {
    id: 3,
    title: "Udźwignąć własne szczęście",
    date: "1991",
    languages: [
      "Wstęp i opracowanie Izolda Kiec. Brama - Książnica Włóczęgów i Uczonych, Poznań",
    ],
    infos:
      "Kreślą się żółte gwiazdy sentymentalną lirą – Artemis biała i smukła w księżyca przegląda się lustrze – taki już gwiezdnych przeznaczeń tajemnie zapadł wyrok: nic cię nie może zbawić, nic cię nie może ustrzec:",
    img: "./assets/img/8.jpg",
    link: "http://ginczanka.is-best.net/agonia/",
  },
  {
    id: 4,
    title: "Krzątanina mglistych pozorów",
    date: "2010",
    languages: [
      "Polsko-włoskie wydanie wierszy Zuzanny Ginczanki (opracowanie, wstęp i przekład: Alessandro Amenta)",
    ],
    infos:
      "Specjalny wybór wierszy Zuzanny Ginczanki, zatytułowany (z ginczańska) Krzątanina mglistych pozorów. Powstały na pamiątkę, jak kamyk kładziony żydowskiej autorce. Bez napuszenia, mimo że w tej specjalnej formie. Tym ciekawiej jest, że to wydanie dwujęzyczne (polsko-włoskie) ...",
    img: "./assets/img/13.jpg",
    link:
      "https://www.taniaksiazka.pl/krzatanina-mglistych-pozorow-wiersze-wybrane-zuzanna-ginczanka-p-266091.html",
  },
  {
    id: 5,
    title: "Wniebowstąpienie ziemi",
    date: "2014",
    languages: ["wiersze wybrane przez Tadeusza Dąbrowskiego"],
    infos:
      "Ściągnąć, zerwać, zmiąć chmury jak zwiotczały płat skóry – niech roztopi was słońce, niech was spali gorącem – Ściągnąć, zerwać wam twarze obojętnie obłudne – – krzyczcie raczej nienawiść przenajkrwiściej okrutną – roztaczajcie się, niszczcie,",
    img: "./assets/img/17.jpg",
    link:
      "https://www.biuroliterackie.pl/biblioteka/ksiazki/wniebowstapienie-ziemi-7/",
  },
  {
    id: 6,
    title: "Mądrość jak rozkosz",
    date: "2017",
    languages: ["wiersze wybrane przez Agatę Araszkiewicz"],
    infos:
      "Niniejszy tomik wydobywa kobiecy rodowód jej poezji jako źródło pulsującej siły, zaprasza czytelniczki i czytelników do nowego projektu widzenia kultury i przewartościowania jej znaczeń.",
    img: "./assets/img/18.jpg",
    link: "https://www.youtube.com/watch?v=NavogQ0-xAg",
  },
  {
    id: 6,
    title: "Poezje zebrane (1931-1944)",
    date: "2019",
    languages: ["Izolda Kiec, Wydawnictwo Marginesy"],
    infos:
      "Oto jest bryła i kształt, oto jest treść nieodzowna, konkretność istoty rzeczy, materia wkuta w rzeczownik, i nieruchomość świata i spokój martwot i stałość, coś, co trwa wciąż i jest, słowo stężone w ciało. Oto są proste stoły ...",
    img: "./assets/img/1.png",
    link: "https://marginesy.com.pl/sklep/produkt/133259/poezje-1931-1944",
  },
];
